(ns ui.view.grid-opensearch.selection
  "Pure helpers for the selection of the grid. With the server-side row model,
   AG Grid does not keep the rows of a select-all. It keeps a state: either
   \"all rows except these\" or \"only these rows\".")

(defn- parse-id
  [id]
  (let [parsed (js/parseInt (str id) 10)]
    (when-not (js/isNaN parsed)
      parsed)))

(defn parse-selection-state
  "Read the server-side selection state that AG Grid returns, after `js->clj`
   without keywordizing. `:toggled-ids` are the rows that the user cleared when
   `:select-all?` is true. They are the selected rows when it is false."
  [state]
  {:select-all? (true? (get state "selectAll"))
   :toggled-ids (->> (get state "toggledNodes")
                     (keep parse-id)
                     vec)})

(defn hits->ids
  "The entity ids of the hits in a search response."
  [resp]
  (->> (get-in resp [:hits :hits])
       (keep (fn [hit]
               (parse-id (get hit :_id))))
       vec))
